var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirConditioner = function SvgAirConditioner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#air-conditioner_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M20 10.002 0 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.616 12.318a.5.5 0 1 0 .768-.64l-.384.32zM16.334 10l-.384.32 1.666 1.998.384-.32.384-.32-1.666-1.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.616 7.678a.5.5 0 1 1 .768.64L18 7.998zm-1.282 2.318-.384-.32 1.666-1.998.384.32.384.32-1.666 1.998zM2.519 7.68a.5.5 0 1 0-.768.64L2.135 8zM3.8 9.998l.384-.32L2.519 7.68 2.135 8l-.384.32 1.666 1.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.519 12.32a.5.5 0 1 1-.768-.64l.384.32zM3.8 10.002l.384.32-1.666 1.998-.384-.32-.384-.32 1.666-1.998z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M14.822 1.24 5.178 18.761"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.7 4.442a.5.5 0 1 0-.19-.982l.095.491zm-2.65.005.096.491 2.554-.496-.095-.491-.096-.49-2.554.495z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.636 2.204a.5.5 0 0 1 .931-.364l-.465.182zm1.413 2.241-.466.182-.947-2.423.466-.182.465-.182.947 2.423zM4.359 15.437a.5.5 0 1 0 .19.982l-.095-.491zm2.649-.005-.096-.491-2.553.496.095.49.095.492 2.554-.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.425 17.675a.5.5 0 0 1-.932.364l.466-.183zm-1.413-2.241.465-.182.948 2.422-.466.183-.466.182-.947-2.423z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m5.174 1.24 9.644 17.521"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.3 4.448a.5.5 0 0 1 .19-.982l-.095.49zm2.65.005-.096.49L4.3 4.449l.095-.491.096-.49 2.554.495z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.366 2.21a.5.5 0 0 0-.931-.364l.465.182zM6.953 4.451l.466.182.947-2.423-.466-.182-.465-.182-.948 2.423zM15.637 15.437a.5.5 0 1 1-.19.982l.095-.491zm-2.649-.005.096-.491 2.553.496-.095.49-.095.492-2.554-.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.573 17.675a.5.5 0 0 0 .932.364l-.466-.183zm1.413-2.241-.465-.182-.948 2.422.466.183.466.182.947-2.423z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "air-conditioner_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgAirConditioner;